export const chargeLimitOptions = [
  {
    title: 'Up to the combined allowable amount',
    caption:
      'Cap at the sum of the in-network allowed amounts for the services rendered — the maximum the patient could owe under contract.',
    value: 'combined-allowable-amount',
    recommended: true
  },
  {
    title: 'Set % higher than the allowable amount',
    caption:
      'Add a buffer above the combined allowable amount (e.g., 10–25% for post-insurance adjustments).',
    value: 'set-higher-allowable-amount',
    recommended: false
  },
  {
    title: 'Set dollar amount limit',
    caption:
      'Add a buffer above the combined allowable amount (e.g., 10–25% for post-insurance adjustments).',
    value: 'set-dollar-amount',
    recommended: false
  },
  {
    title: 'Up to the full cost of actual services received (self-pay)',
    caption: `Authorizes charges up to your practice's self-pay fees for the services actually rendered. Used when the patient's in-network coverage doesn't apply to a service.`,
    value: 'full-cost',
    recommended: false
  }
];

export const chargeLimitAlertOptions = [
  { title: 'Copayment', description: 'fixed in-network copay collected at time of visit' },
  { title: 'Deductible', description: 'remaining in-network deductible applied' },
  { title: 'Coinsurance', description: "patient's in-network share after deductible" }
];
